import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularUiModule } from '@univacity/angular/ui';
import { RoutePath, Tour } from '@univacity/shared/types';
import { AuthService, FxRateService } from '@univacity/angular/datas';

@Component({
  selector: 'un-tour-detail-footer',
  imports: [CommonModule, AngularUiModule],
  templateUrl: './tour-detail-footer.component.html',
  styleUrls: ['./tour-detail-footer.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourDetailFooterComponent {
  @Input() tour: Tour;
  @Output() book = new EventEmitter<void>();

  RoutePath = RoutePath;

  constructor(public auth: AuthService, public fx: FxRateService) {}
}
